import { LOGOTIPO } from './Logotipo.tsx';
import './loading-mark.css';

/**
 * O símbolo do logótipo como indicador de carregamento — o braço âmbar a
 * rolar sobre a marca azul parada. Ver a skill `animacao-mimo`.
 *
 * Os traçados vêm de `LOGOTIPO`, o mesmo objecto que `Logotipo.tsx` usa e que
 * `Logotipo.test.ts` mantém fiel a `src/assets/marca/yelela-mark.svg`. Não há
 * cópia nova para divergir: é a marca da aplicação, só que a rodar.
 *
 * Puramente decorativo — o estado de carregamento anuncia-se por texto em
 * `role="status"`, em `EstadoACarregar`, não pelo desenho.
 */
export function LoadingMark({ tamanho = 'normal' }: { tamanho?: 'normal' | 'grande' }) {
  return (
    <span
      className={tamanho === 'grande' ? 'marca-a-carregar marca-a-carregar--grande' : 'marca-a-carregar'}
      aria-hidden="true"
    >
      <svg className="marca-a-carregar__desenho" viewBox="0 0 438 477" focusable="false">
        <path className="marca-a-carregar__azul" d={LOGOTIPO.azul} />
        <path className="marca-a-carregar__ambar" d={LOGOTIPO.ambar} />
      </svg>
    </span>
  );
}

/**
 * O padrão completo de "a carregar": a marca e a frase que diz o quê. Usado
 * nos quatro sítios que esperam por conteúdo de rede — catálogo, módulo,
 * lição — para não repetir a mesma marcação em cada um.
 */
export function EstadoACarregar({ texto }: { texto: string }) {
  return (
    <div className="estado-a-carregar" role="status">
      <LoadingMark />
      <p>{texto}</p>
    </div>
  );
}
